import {DateTime} from 'luxon';

export const dateTimeIntervals = [
  {
    text: 'Предыдущая неделя',
    value: 'prevWeek',
    handle: () => {
      const endPrevWeek = DateTime.local()
        .startOf('week')
        .minus({day: 1});
      return {
        startDateTime: endPrevWeek.startOf('week').valueOf(),
        endDateTime: endPrevWeek.endOf('week').valueOf(),
      };
    },
  },

  {
    text: 'Вчера',
    value: 'yesterday',
    handle: () => {
      const yesterday = DateTime.local().plus({days: -1});
      const year = yesterday.year;
      const month = yesterday.month;
      const day = yesterday.day;
      return {
        startDateTime: DateTime.local(year, month, day).valueOf(),
        endDateTime: DateTime.local(year, month, day, 23, 59, 59).valueOf(),
      };
    },
  },
  {
    text: 'Сегодня',
    value: 'today',
    handle: () => {
      return {
        startDateTime: DateTime.local()
          .startOf('day')
          .valueOf(),
        endDateTime: DateTime.local().valueOf(),
      };
    },
  },
  {
    text: 'Текущий месяц',
    value: 'currentMonth',
    handle: () => {
      return {
        startDateTime: DateTime.local()
          .startOf('month')
          .valueOf(),
        endDateTime: DateTime.local().valueOf(),
      };
    },
  },
  {
    text: 'Текущая неделя',
    value: 'currentWeek',
    handle: () => {
      return {
        startDateTime: DateTime.local()
          .startOf('week')
          .valueOf(),
        endDateTime: DateTime.local().valueOf(),
      };
    },
  },
  {
    text: 'Последние 7 дней',
    value: 'lastSevenDays',
    handle: () => {
      return {
        startDateTime: DateTime.local()
          .minus({days: 7})
          .valueOf(),
        endDateTime: DateTime.local().valueOf(),
      };
    },
  },
  {
    text: 'Последние 30 дней',
    value: 'lastThirtyDays',
    handle: () => {
      return {
        startDateTime: DateTime.local()
          .minus({days: 30})
          .valueOf(),
        endDateTime: DateTime.local().valueOf(),
      };
    },
  },
  {
    text: 'Предыдущий месяц',
    value: 'prevMonth',
    handle: () => {
      const dtLocal = DateTime.local();
      return {
        startDateTime: dtLocal
          .startOf('month')
          .minus({month: 1})
          .valueOf(),
        endDateTime: dtLocal
          .minus({month: 1})
          .endOf('month')
          .valueOf(),
      };
    },
  },
];

export function dateTimeIntervalHandle(interval: DatesIntervals): DateTimeInterval {
  const intervalObject = dateTimeIntervals.find((item: any) => item.value === interval);
  if (!intervalObject) throw new Error(`${interval} - такого интервала не существует`);
  return intervalObject.handle();
}

export interface DateTimeInterval {
  startDateTime: number | undefined;
  endDateTime: number | undefined;
}

export default {
  dateTimeIntervals,
  dateTimeIntervalHandle,
};

export type DatesIntervals =
  | 'prevWeek'
  | 'yesterday'
  | 'today'
  | 'currentMonth'
  | 'currentWeek'
  | 'lastSevenDays'
  | 'lastThirtyDays'
  | 'prevMonth'
  | '';
